import { useState, useEffect } from "react";
import DetailsIconButton from "../../components/IconButtons/DetailsIconButton";
import {formatDate} from '../../formatters/date';
//import { Dialog } from "@headlessui/react";
// import toast from "react-hot-toast";
import {Implementa} from '../../components';
import { useStateContext } from '../../contexts/ContextProvider';
import DataTable from 'react-data-table-component';
import { getImplementa } from "../../services/Implementa";
import { FolderIcon, UserIcon } from '@heroicons/react/24/solid';

const EquipmentReviewInboxFull  = () =>  {
  const { handleClick, isClicked } = useStateContext();
  const [data, setData] = useState([]);
  //const [filters, setFilters] = useState({ mandante: "", proyecto: "", estado: [] });
  const [laSucursal, setLaSucursal] = useState("");
  const [archivosData, setArchivosData] = useState([]);
  const [centroCosto, setCentroCosto] = useState('');
  const [estado, setEstado] = useState('ALL');
  const [fechaFiltro, setFechaFiltro] = useState("");
  const [numInternoFiltro, setNumInternoFiltro] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const misImplementa = await getImplementa(centroCosto, estado, fechaFiltro, numInternoFiltro);
      setArchivosData(misImplementa);
      //console.log("misImplementa: ", JSON.stringify(misImplementa));
      const dataTemp = procesarDatosParaTabla(misImplementa);
      setData(dataTemp);  
    };
    fetchData();
    
  }, [centroCosto, estado, fechaFiltro, numInternoFiltro]);

  const procesarDatosParaTabla = (data) => {
    let rows = [];
  
    data.forEach((solicitud) => {
      solicitud.detalleAsignados.forEach((equipo) => {
        if (solicitud.lin === equipo.lin) { // Comparar "lin" de la solicitud con "lin" del equipo
        // console.log("equipo: ", equipo  );
          rows.push({
            _id: solicitud._id,
            numeroSolicitud: solicitud.numeroSolicitud || 0,
            fechaSolicitud: solicitud.fechaCreacionSol || null,
            codigoCentro: solicitud.codigo || "N/A",
            nombreProyecto: solicitud.nombreProyecto || "N/A",
            codigoEquipo: equipo.codigoEquipo || "N/A",
            estado: solicitud.estado || "N/A",
            ubicacion: solicitud.ubicacion || "N/A",
          });
        }
      });
    });
  
    rows.sort((a, b) => (b.numeroSolicitud || 0) - (a.numeroSolicitud || 0));
    return rows;
  };
  
  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  }

  const handleChangeFecha = (e) =>{
    setFechaFiltro( e.target.value );
  }

  const handleChangeNumInterno = (e) =>{
    setNumInternoFiltro( e.target.value );
  }

  const handleRefreshDataTable = (opcion) => {
    // console.log(" OPCION LLEGO -> " + opcion);
    if (opcion==="REFRESH"){
      const fetchData = async () => {
          const misImplementa = await getImplementa(centroCosto, estado, fechaFiltro, numInternoFiltro);
          setArchivosData(misImplementa);
          const dataTemp = procesarDatosParaTabla(misImplementa);
          setData(dataTemp);
          setLaSucursal(prev => {
            if (!prev || !prev._id) return prev;
            const refreshed = misImplementa.find(item => item._id === prev._id);
            return refreshed || prev;
          });
      };
      fetchData();
    }
  };

  const handleEdit = (row) => {

    const sucursal = archivosData.find((sucursal) => sucursal._id === row._id);

    setLaSucursal(sucursal);
    handleClick('nuevoImplementa');
    };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};


  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DetailsIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: 'N° Solicitud',
      width: '120px',
      selector: row => row.numeroSolicitud,
      sortable: true
    },
    {
      name: 'Fecha Solicitud',
      width: '150px',
      selector: row => row.fechaSolicitud ? formatDate(row.fechaSolicitud) : '-',
      sortable: true
    },
    {
      name: 'C.Costo',
      width: '120px',
      selector: row => row.codigoCentro,
      sortable: true
    },
    {
      name: 'Proyecto',
      width: '400px',
      selector: row => row.nombreProyecto,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <FolderIcon className="w-4 h-4 text-blue-500" />
        <span>{row.nombreProyecto}</span>
      </div>
      )
    },
    {
      name: 'N° Interno',
      width: '150px',
      selector: row => row.codigoEquipo,
      sortable: true
    },
    {
    name: 'Estado',
    width: '120px',
    selector: row => row.estado,
    sortable: true,
    cell: (row) => {
      let bgColor = '';
      switch (row.estado) {
        case 'Aprobada':
          bgColor = 'bg-green-100 text-green-700';
          break;
        case 'Pendiente':
          bgColor = 'bg-yellow-100 text-yellow-700';
          break;
        case 'Rechazada':
          bgColor = 'bg-red-100 text-red-700';
          break;
        case 'En Proceso':
          bgColor = 'bg-blue-100 text-blue-700';
          break;
        default:
          bgColor = 'bg-gray-100 text-gray-700';
      }
      return (
        <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
          {row.estado}
        </div>
      );
    }
  },
    {
      name: 'Ubicación',
      width: '200px',
      selector: row => row.ubicacion,
      sortable: true
    }
  ];

  return (
    <>
    <div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                Implementación
              </p>
            </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
          <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
          <div className="grid grid-cols-2 md:grid-cols-6 gap-4 justify-between" >
              {/* N° Solicitud */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">C.Costo</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder=""
                value={centroCosto}
                onChange={(e) => setCentroCosto(e.target.value)}
              />
            </div>
              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Estado</label>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value= {estado} required onChange={handleChangeEstado}>   
                  <option value="ALL">Todos</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="Rechazado">Rechazado</option>  
                  <option value="Finalizado">Finalizado</option>   
                  </select>
              </div>  

              <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Fecha Solicitud</label>
              <input
                type="date"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder=""
                value={fechaFiltro}
                onChange={handleChangeFecha}
              />
            </div>
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">N° Interno</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder=""
                value={numInternoFiltro}
                onChange={handleChangeNumInterno}
              />
            </div>

       </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
          <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
              <div className="flex flex-col">
                  {/* Tabla principal */}
                  <DataTable
                    columns={columns}
                    data={data}
                    highlightOnHover
                    pagination={true}
                    striped
                    className="border border-gray-300 rounded-lg shadow-sm"
                    noHeader={true}
                    selectableRowsHighlight
                    customStyles={customStyles}
                    noDataComponent={'No hay -equipos asignados- para autorizar'}
                  />
              </div>
          </div>
        </div>
      {isClicked.nuevoImplementa && (<Implementa vecinoData={laSucursal}  onChangeVecino={handleRefreshDataTable}/>)}
    </div>
    </>
  );
}


export default EquipmentReviewInboxFull;